type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
};

export function ToggleRow({
  checked,
  onChange,
  label,
  description,
  disabled = false,
}: Props) {
  return (
    <label
      className={`flex items-center justify-between gap-4 rounded-2xl border border-border/70 bg-white p-4 ${
        disabled ? 'opacity-60' : ''
      }`}
    >
      <span className="flex flex-col">
        <span className="font-semibold text-ink">{label}</span>
        {description ? (
          <span className="mt-1 text-xs font-normal text-muted">
            {description}
          </span>
        ) : null}
      </span>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className="h-5 w-5 shrink-0 accent-accent"
      />
    </label>
  );
}
